// Mantún (13-10-2026, portado de FunFungi): bloque «Cuotas» de la ficha (blocks/mt-cuotas.liquid).
// El total sale de la opción elegida en Kaching más los agregados marcados (igual que mt-barra-precio.js);
// sin Kaching, del precio que muestra el tema (cambia con la variante) y, si no hay, del precio con que se dibujó el bloque.
// Cuota = total / cuotas, redondeada hacia arriba para nunca mostrar menos de lo que se cobra.
// La elección del cliente (3, 6 o 12) se recuerda en la sesión para las otras fichas.
(function () {
  if (window.mtCuotas) return;
  window.mtCuotas = true;

  var CLAVE = 'mt:cuotas';

  function numero(el) {
    return el ? parseInt(el.textContent.replace(/\D/g, ''), 10) || 0 : 0;
  }
  function plata(n) {
    return '$' + n.toLocaleString('es-CL');
  }
  function poner(el, texto) {
    if (el && el.textContent !== texto) el.textContent = texto;
  }
  function leerEleccion() {
    try { return parseInt(sessionStorage.getItem(CLAVE), 10) || 0; } catch (e) { return 0; }
  }
  function guardarEleccion(n) {
    try { sessionStorage.setItem(CLAVE, String(n)); } catch (e) {}
  }

  function raizDe(widget) {
    return document.getElementById('shopify-section-' + widget.dataset.section) || document;
  }

  function totalKaching(raiz) {
    var opcion = raiz.querySelector('.kaching-bundles__bar--selected') || document.querySelector('.kaching-bundles__bar--selected');
    if (!opcion) return 0;
    var total = numero(opcion.querySelector('.kaching-bundles__bar-price'));
    if (!total) return 0;
    opcion.querySelectorAll('.kaching-bundles__upsell').forEach(function (u) {
      if (u.querySelector('.kaching-bundles__upsell__checkbox--selected')) total += numero(u.querySelector('.kaching-bundles__upsell__price'));
    });
    return total;
  }

  function totalTema(widget) {
    var cont = document.querySelector('#price-' + widget.dataset.section + ' .price');
    if (!cont) return 0;
    var el = cont.classList.contains('price--on-sale')
      ? cont.querySelector('.price__sale .price-item--sale')
      : cont.querySelector('.price__regular .price-item--regular');
    return numero(el);
  }

  // 17-10-2026 (escalera nativa): sin Kaching Bundles, el total sale de la opción marcada en la escalera de Shrine.
  function totalEscalera() {
    var r = document.querySelector('quantity-breaks input[name="quantity"]:checked');
    var lab = r && r.id && document.querySelector('label[for="' + r.id + '"]');
    return lab ? numero(lab.querySelector('.quantity-break__price')) : 0;
  }

  function total(widget) {
    return totalKaching(raizDe(widget)) || totalEscalera() || totalTema(widget) || parseInt(widget.dataset.precio, 10) || 0;
  }

  function cuotasDe(widget) {
    var botones = widget.querySelectorAll('[data-mtc-opcion]');
    if (!botones.length) return parseInt(widget.dataset.inicio, 10);
    var marcado = widget.querySelector('[data-mtc-opcion][aria-pressed="true"]');
    return parseInt((marcado || botones[botones.length - 1]).dataset.mtcOpcion, 10);
  }

  function pintar(widget) {
    var n = cuotasDe(widget);
    var t = total(widget);
    var minimo = parseInt(widget.dataset.minimo, 10) || 0;
    var visibles = 0;
    widget.querySelectorAll('[data-mtc-max]').forEach(function (p) {
      var ocultar = parseInt(p.dataset.mtcMax, 10) < n;
      if (p.hidden !== ocultar) p.hidden = ocultar;
      if (!ocultar) visibles++;
    });
    var esconder = !t || t < minimo || !visibles;
    if (widget.hidden !== esconder) widget.hidden = esconder;
    if (esconder) return;
    widget.querySelectorAll('[data-mtc-n]').forEach(function (e) { poner(e, String(n)); });
    widget.querySelectorAll('[data-mtc-monto]').forEach(function (e) { poner(e, plata(Math.ceil(t / n))); });
  }

  function elegir(widget, n) {
    widget.querySelectorAll('[data-mtc-opcion]').forEach(function (b) {
      var si = parseInt(b.dataset.mtcOpcion, 10) === n ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== si) b.setAttribute('aria-pressed', si);
    });
    pintar(widget);
  }

  function iniciar(widget) {
    if (widget.dataset.mtcListo) return;
    widget.dataset.mtcListo = '1';
    var guardada = leerEleccion();
    if (guardada && widget.querySelector('[data-mtc-opcion="' + guardada + '"]')) elegir(widget, guardada);

    widget.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mtc-opcion]');
      if (!b) return;
      var n = parseInt(b.dataset.mtcOpcion, 10);
      guardarEleccion(n);
      elegir(widget, n);
    });

    // Kaching dibuja sus opciones unos segundos después y las vuelve a dibujar al elegir: mirar la sección entera.
    // Se ignoran los cambios dentro del propio bloque para no entrar en bucle.
    var pendiente = false;
    var raiz = raizDe(widget);
    new MutationObserver(function (cambios) {
      if (pendiente) return;
      for (var i = 0; i < cambios.length; i++) {
        if (!widget.contains(cambios[i].target)) {
          pendiente = true;
          requestAnimationFrame(function () {
            pendiente = false;
            pintar(widget);
          });
          return;
        }
      }
    }).observe(raiz === document ? document.body : raiz, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    // Marcar un radio de la escalera no cambia el DOM (es una propiedad): escuchar el cambio.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') requestAnimationFrame(function () { pintar(widget); });
    });
    pintar(widget);
  }

  function todos() {
    document.querySelectorAll('[data-mtc]').forEach(iniciar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos);
  else todos();
  // En el editor de temas el bloque se vuelve a dibujar al cambiar un ajuste
  document.addEventListener('shopify:section:load', todos);
  document.addEventListener('shopify:block:select', todos);
})();
